import { AdminRoleName } from "src/types/account";

export const SERVICE_PROVIDER_ROLE: AdminRoleName = "service_provider";
export const ADMIN_ROLE: AdminRoleName = "admin";

export const ADMIN_ROLE_NAME: Record<AdminRoleName, string> = {
  service_provider: "サービス提供者",
  admin: "管理者",
};

export const ROLE_NUMBER_TO_STRING = {
  0: ADMIN_ROLE,
  1: SERVICE_PROVIDER_ROLE,
} as const;

export const ACCOUNT_TABLE_HEAD = [
  { id: "id", label: "ID", sortColumn: "id" },
  { id: "name", label: "アカウント名", sortColumn: "name" },
  { id: "type", label: "種別", sortColumn: "role" },
  { id: "createdAt", label: "アカウント作成日時", sortColumn: "created_at" },
  { id: "updated", label: "アカウント更新日時", sortColumn: "updated_at" },
];

export const ACCOUNT_TYPE_OPTIONS = [
  { value: "service_provider", label: "サービス提供者" },
  { value: "admin", label: "管理者" },
] as const;

export enum AccountType {
  ADMIN = 0,
  SERVICE_PROVIDER = 1,
}
export const ACCOUNT_TYPE_LABELS = {
  service_provider: "サービス提供者",
  admin: "管理者",
} as const;
